import { STAGE, DEBUG, MOCK_PASSKEY } from 'shared-modules/config';

const isMockPasskey = DEBUG === 'true' && MOCK_PASSKEY === 'true';

const rpId = (() => {
  if (process.env.NODE_ENV === 'development') {
    return 'localhost'; // ただしMobileでは使用不可
  }
  switch (STAGE) {
    case 'DEVELOPMENT':
      return 'dev.ta23.invast.jp';
    case 'RELEASE':
      return 'stg.ta23.invast.jp';
    default:
      return null;
  }
})();

const base64urlToArrayBuffer = (base64url) => {
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
  const binary = atob(padded);
  return Uint8Array.from(binary, (c) => c.charCodeAt(0)).buffer;
};
const randomBytes = (length) => {
  return crypto.getRandomValues(new Uint8Array(length));
};

const createPasskey = async ({ login }) => {
  if (!rpId) {
    throw new Error('STAGE error.');
  }
  // 通常はサーバーから取得する
  const optionsFromServer = {
    userId: login,
    username: login,
    displayName: login,
    rpName: 'トライオート',
    rpId,
  };
  const challenge = randomBytes(32); // 32バイトのランダム値
  const credential = await navigator.credentials.create({
    publicKey: {
      challenge,
      rp: {
        name: optionsFromServer.rpName,
        id: optionsFromServer.rpId,
      },
      user: {
        id: base64urlToArrayBuffer(optionsFromServer.userId),
        name: optionsFromServer.username,
        displayName: optionsFromServer.displayName,
      },
      pubKeyCredParams: [
        { type: 'public-key', alg: -7 }, // ES256
        { type: 'public-key', alg: -257 }, // RS256
      ],
      authenticatorSelection: {
        residentKey: 'required',
        userVerification: 'preferred',
      },
      timeout: 60000,
      attestation: 'none',
    },
  });
  return credential;
};

const getPasskey = async () => {
  if (!rpId) {
    throw new Error('STAGE error.');
  }
  const assertion = await navigator.credentials.get({
    publicKey: {
      challenge: randomBytes(32),
      rpId,
      userVerification: 'preferred',
      timeout: 60000,
      // allowCredentials を省略すると、
      // この RP に登録されている Passkey が候補になる
    },
  });
  return assertion;
};

export default {
  isMockPasskey,
  rpId,
  randomBytes,
  base64urlToArrayBuffer,
  createPasskey,
  getPasskey,
};
